module.exports = __webpack_public_path__ + "img/small-3.a4caf1a5.webp";